import {
  FunctionComponent,
  useState,
  ChangeEvent,
  SyntheticEvent,
} from "react";
import { HighlightedSearchesServices } from "../../../../services/highlightedSearches";
import CreateHighlightedSearch from "../AdminHighlightedSearches/createHighlightedSearch";
import { Icon } from "../../../Icon";

import "./GetAllHighlightedSearches.scss";
import { toast } from "react-toastify";
import Label from "../../../Label";

type Props = {
  searches: Search[];
  setNewHighlightedSearch: React.Dispatch<React.SetStateAction<any>>;
};

const GetAllHighlightedSearches: FunctionComponent<Props> = ({
  searches,
  setNewHighlightedSearch,
}) => {
  const [enableEditing, setEnableEditing] = useState<number | null>(null);
  const [editSearch, setEditSearch] = useState<Search>({
    _id: "",
    search: "",
  });
  const collapsible = (gauge: string) => (
    <div className="trigger">
      <p>{gauge}</p>
    </div>
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>, _id: string) => {
    setEditSearch({
      ...editSearch,
      [e.target.name]: e.target.value,
    });
  };

  const handleDelete = (_id: string) => {
    HighlightedSearchesServices.deleteSearch(_id).then((r) => {
      toast.success("Eliminado correctamente");
      setNewHighlightedSearch(true);
    });
  };

  const handleEdit = (_id: string, e: SyntheticEvent, search: Search) => {
    e.preventDefault();
    HighlightedSearchesServices.editSearch(_id, editSearch.search);
    search.search = editSearch.search;
    setEditSearch({ search: "", _id: "" });
  };

  const handleAllowEditing = (index: number) => {
    setEnableEditing(index);
  };

  const handleCloseEditing = () => {
    setEnableEditing(null);
  };

  return (
    <div className="highlightedSearchContainer">
      <Label tag="h3" style={{ fontFamily: "Mont-Semibold" }}>
        Busquedas sugeridas
      </Label>

      <CreateHighlightedSearch
        setNewHighlightedSearch={setNewHighlightedSearch}
      />
      <div className="highlightedSearchHead">
        {searches.length > 0 && (
          <div className="highlightedSuggestedSearchHeadTitle">
            <p>TÍTULO</p>
          </div>
        )}
      </div>

      {searches.map((s, index) => {
        return (
          <div className="highlightedSearchItems" key={s._id}>
            <div className="highlightedSuggestedSearchTitle">
              <p>{s.search}</p>
            </div>

            <div className="highlightedSuggestedSearchActions">
              <button className="trash" onClick={() => handleDelete(s._id)}>
                <Icon iconName="trash_cart" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GetAllHighlightedSearches;

/*  {enableEditing === index ? (
                <form
                  className="highlightedSuggestedSearchForm"
                  onSubmit={(e) => handleEdit(s._id, e, s)}
                >
                  <input
                    type="text"
                    id="search"
                    name="search"
                    value={editSearch.search}
                    onChange={(e) => handleChange(e, s._id)}
                  />
                  <button type="submit">Confirmar</button>
                  <button
                    type="button"
                    className="close"
                    onClick={handleCloseEditing}
                  >
                    Cerrar
                  </button>
                </form>
              ) : null}*/
